import { render, staticRenderFns } from "./RemoteIslandTypeNameColumn.vue?vue&type=template&id=62aee1ae&"
import script from "./RemoteIslandTypeNameColumn.vue?vue&type=script&lang=js&"
export * from "./RemoteIslandTypeNameColumn.vue?vue&type=script&lang=js&"
import style0 from "./RemoteIslandTypeNameColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62aee1ae')) {
      api.createRecord('62aee1ae', component.options)
    } else {
      api.reload('62aee1ae', component.options)
    }
    module.hot.accept("./RemoteIslandTypeNameColumn.vue?vue&type=template&id=62aee1ae&", function () {
      api.rerender('62aee1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/RemoteIslandTypeNameColumn.vue"
export default component.exports